import { createSlice } from "@reduxjs/toolkit";
import { IUser, TContentConfig } from "@repo/database";

export type TSessionUser = Omit<IUser, "_id" | "contentConfig" | "subscriptionData"> & {
  id: string,
  contentConfig: Omit<TContentConfig, "avatar"> & {
    interviewTaken: boolean
  },
  hasAccess: boolean
}

type UserPropertyTypes = {
  [Property in keyof TSessionUser]: TSessionUser[Property];
};

export type IUserKeyValue = Partial<UserPropertyTypes>;

export interface IUserDataState {
  loaded: boolean;
  userData?: TSessionUser
}

const initialState: IUserDataState = {
  loaded: false,
  userData: undefined,
};

export const userDataSlice = createSlice({
  name: "user-data-slice",
  initialState,
  reducers: {
    setUserData: (
      state: IUserDataState,
      action: { payload: { userData: TSessionUser } }
    ) => {
      state.userData = action.payload.userData;
      state.loaded = true;
    },
    updateUserData: (state: IUserDataState, action: { payload: {values: IUserKeyValue}}) => {
      state.userData = { ...state.userData, ...action.payload.values } as TSessionUser;
    }
  },
});

export const {
  setUserData,
  updateUserData
} = userDataSlice.actions;

export default userDataSlice.reducer;
